const excludeConfigKeys = ['transformRequest', 'transformResponse'];

export class AxiosIntegration {
    static id = 'Axios';
    name = AxiosIntegration.id;

    setupOnce(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor((event, hint) => {
            const self = getCurrentHub().getIntegration(AxiosIntegration);
            if (self) {
                return self.process(event, hint);
            }
            return event;
        });
    }

    filterConfig(key, value) {
        if (typeof value === 'function') return false;
        if (excludeConfigKeys.includes(key)) return false;
        return true;
    }

    process(event, hint) {
        const contexts = {};
        const error = hint.originalException;

        if (error?.isAxiosError) {
            const axiosConfig = error.config;
            const serializableConfig = {};
            Object.entries(axiosConfig).forEach(([key, value]) => {
                if (this.filterConfig(key, value)) {
                    // eslint-disable-next-line better-mutation/no-mutation
                    serializableConfig[key] = value;
                }
            });
            contexts.axios = {
                config: serializableConfig,
                response: {
                    status: error.response?.status,
                    statusText: error.response?.statusText
                }
            };
        }

        return {
            ...event,
            contexts: {
                ...event.contexts,
                ...contexts
            }
        };
    }
}
